"use client";

import React from "react";

import Image from "next/image";
import DecorationLine from "@/components/global/ui/DecorationLine";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";

import {PageLiveCallSchema} from "@/sanity/pages/PageLiveCallTemplate";

export default function NumbersSection({
  data,
  className
}: {
  data: PageLiveCallSchema;
  className?: string;
}) {

  return (
    <section className={cn(
      "relative overflow-clip",
      className
    )}>
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="left"
      />
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="right"
      />

      <div className="relative pt-[4rem]">
        <DecorationLine
          className="top-[4rem]"
          orientation="horizontal"
        />
        <DecorationLine
          className="bottom-0"
          orientation="horizontal"
        />

        {data?.numbersItems && (
          <div className="px-[1rem] sm:px-[3rem] lg:px-[7rem] grid grid-cols-1 lg:grid-cols-3">
            {data?.numbersItems.map((item, index) => (
              <div
                key={index}
                className="flex lg:flex-col items-center justify-start lg:justify-center gap-[3rem] lg:gap-[2rem] py-[2.5rem] lg:py-[5rem] relative pl-[12%] lg:pl-0"
              >
                {item?.icon && (
                  <Image
                    className="!w-[7rem]"
                    src={item.icon}
                    alt=""
                  />
                )}

                {item?.text && (
                  <div className="richtext richtext-start lg:richtext-center prose-em:leading-none prose-em:font-ivy prose-em:tracking-[0.3px] prose-em:font-light prose-em:text-[4rem] lg:prose-em:text-[5rem] prose-em:text-black prose-p:text-black/90">
                    <PortableText
                      value={item.text}
                      components={richTextComponent}
                    />
                  </div>
                )}

                {index < data.numbersItems.length - 1 && (
                  <>
                    <DecorationLine
                      className="top-0 right-0 hidden lg:block"
                      orientation="vertical"
                    />
                    <DecorationLine
                      className="bottom-0 left-0 lg:hidden"
                      orientation="horizontal"
                    />
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
